// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Landing 묶음
import Home from "./components/Home";
import Intro from "./components/Intro";
import Project from "./components/Project";
import Contact from "./components/Contact";

// 상세 페이지
import Project_bms from "./components/Project_bms";
import Project_bmi from "./components/Project_bmi"; // 파일명이 Project_bim.js면 import만 바꾸세요
import Project_cc from "./components/Project_cc";

/** 라우트 변경 시 상단 이동 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// 파일: src/App.js (동일 파일 상단에 추가)
const HashScroller = ({ offset = 0 }) => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const tryScroll = () => {
      const el = document.querySelector(location.hash);
      if (!el) {
        return false;
      }
      const y = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
      return true;
    };

    // 즉시 시도 후, 실패 시 다음 프레임/틱에서 재시도 (DOM 마운트 대기)
    if (!tryScroll()) {
      requestAnimationFrame(() => {
        setTimeout(tryScroll, 0);
      });
    }
  }, [location.pathname, location.hash, offset]);

  return null;
};


/** 실제 앱 셸: 경로에 따라 전역 UI를 토글 */
const AppShell = () => {
  const { pathname } = useLocation();
  const [showGoTop, setShowGoTop] = useState(false);

  // /project/* 인지 여부
  const isDetail = pathname.startsWith("/project/");

  useEffect(() => {
    AOS.init({ disable: "mobile" });
    AOS.refresh();
  }, []);

  // 스크롤 내려가면 상단으로 버튼 노출
  useEffect(() => {
    const onScroll = () => setShowGoTop(window.scrollY > 200);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // 상세 페이지에서는 전역 헤더 숨김용 클래스(선택)
  useEffect(() => {
    document.body.classList.toggle("detail-page", isDetail);
  }, [isDetail]);

  return (
    <>
      <ScrollToTop />
      <HashScroller />

      {/* 랜딩에서만 전역 배경 & 전역 Navbar 노출 */}
      {!isDetail && (
        <>
          <Navbar />
          <div className="backgrounds overlay">
            <div
              className="background"
              data-aos="fade-in"
              data-aos-duration="1500"
              data-aos-anchor=".section--hero"
            />
          </div>
        </>
      )}

      <Routes>
        {/* 랜딩 */}
        <Route
          path="/"
          element={
            <div className="contents">
              <Home id="home"/>
              <Intro id="intro"/>
              <Project id="project"/>
              <Contact id="contact"/>
            </div>
          }
        />

        {/* 상세 페이지들 – 이 화면들 안에서는 LocalNav를 자체적으로 렌더링 */}
        <Route path="/project/bms" element={<Project_bms />} />
        <Route path="/project/bim" element={<Project_bmi />} />
        <Route path="/project/cc" element={<Project_cc />} />

        {/* 존재하지 않는 경로는 메인으로 */}
        <Route
          path="*"
          element={
            <div className="contents">
              <Home />
              <Intro />
              <Project />
              <Contact />
            </div>
          }
        />
      </Routes>

      <footer className="container-fluid p-0">
        <Footer />
      </footer>

      {/* 상단으로 버튼 — 상세에서도 루트로 이동하게 /#home 사용 */}
      <div className="fixed-md-bottom">
        <a
          href="#top"
          className={showGoTop ? "d-inline-flex" : "d-none"}
          aria-label="Go to top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <i className="bi bi-chevron-up"></i>
        </a>
      </div>
    </>
  );
};

const App = () => (
  <BrowserRouter>
    <AppShell />
  </BrowserRouter>
);

export default App;
